module.exports = __webpack_public_path__ + "img/shiyongBg.e92e261e.png";